import axiosInstance from "../axiosInstance"
import type { WalletResponseDto } from "../types/wallet.types"

export const walletClient = {
  getWalletByUserId: (userId: string): Promise<WalletResponseDto> => {
    return axiosInstance.get(`/wallet/admin/${userId}`)
  },
}
